import React, { useEffect, useState } from "react";
import {
  googleDocsViewer,
  mozillaDocsViwer,
} from "../../utils/journeyConstants";
import { Typography } from "@mui/material";
interface PDFViewerProps {
  pdfUrl: string;
  partnerStartedJourney?: boolean;
}

const PDFViewer: React.FC<PDFViewerProps> = ({
  pdfUrl,
  partnerStartedJourney,
}) => {
  
  const [pdfUrlData, setPdfUrlData] = useState(pdfUrl);

  useEffect(() => {
    if (partnerStartedJourney) {
      setPdfUrlData(pdfUrl)
    } else if(pdfUrl.includes("https")) {
      setPdfUrlData(pdfUrl)
    } else {
      setPdfUrlData(`${mozillaDocsViwer}?file=${encodeURIComponent(pdfUrl)}`);
    }
  }, [pdfUrl, partnerStartedJourney]);

  return (
    <>
      {pdfUrlData ? (
        <iframe
          src={pdfUrlData}
          height="500px"
          style={{
            border: "none",
            width: "100%",
            height: "100%",
            // minHeight: "400px",
            backgroundColor: "#f5f5f5",
          }}
          title="PDF Viewer"
          allow="fullscreen"
        />
      ) : (
        <Typography>Loading...</Typography>
      )}
    </>
  );
};

export default PDFViewer;